import { render, staticRenderFns } from "./OnModeration.vue?vue&type=template&id=da5f5ba8&scoped=true"
import script from "./OnModeration.vue?vue&type=script&lang=js"
export * from "./OnModeration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5f5ba8",
  null
  
)

export default component.exports